<script setup lang="ts">
    import GetTheAppButton from '@components/GetTheAppButton/GetTheAppButton.vue';
</script>

<template>

    <div class="max-w-5xl mx-auto px-8">
        <div class="tracking-wider pt-48 pb-24 lg:-mx-5 xl:-mx-16">
            <div class="text-6xl font-semibold rounded-3xl bg-gray-50 pr-4">

                <div class="flex justify-center z-10">
                    <img src="@/assets/images/Screenshots/cashback.png" class="w-2/3 md:w-1/2 -mt-64"/>
                </div>
                <div class="flex mt-0 w-full items-center md:-mt-40">
                    <div class="basis-1/2 md:basis-2/5 -left-8 lg:-left-12 lg:-mt-16 scale-[140%] sm:scale-[110%] md:scale-100 z-10">
                        <img src="@/assets/images/Home/couple.png" class="w-full z-10"/>
                        <div class="bg-red-500 w-full h-20 absolute bottom-0 left-0 z-10 rounded-bl-3xl"
                             style="background: linear-gradient(0deg, rgba(248,249,251,1) 0%, rgba(248,249,251,0) 100%);"></div>
                    </div>
                    <div class="basis-1/2 md:basis-3/5 text-2xl md:text-3xl pb-8">
                        <img src="@/assets/images/Home/quote.png" class="-left-32 -top-24 md:-left-16 md:mt-16"/>
                        <h1 class="-mt-40 md:-mt-24">
                            We have two cars, and we use
                            <br class="hidden lg:inline" />
                            <strong class="text-primary-600">Carbucks</strong> to stay on top of the costs
                        </h1>
                        <p class="text-lg font-normal mt-3">&bull; Jon and Rihanna <span class="hidden md:inline">McNally</span></p>
                        <GetTheAppButton class="mt-6"/>
                    </div>
                </div>
            </div>

        </div>
    </div>

</template>